import React from 'react';
const links = [{
  label: 'support@screenandadapt.com [placeholder]',
  href: 'mailto:support@screenandadapt.com'
}, {
  label: '@screenandadapt [placeholder]',
  href: '#'
}, {
  label: 'Terms & Conditions',
  href: '#'
}, {
  label: 'Privacy Policy',
  href: '#'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-white/70" data-id="element-119" data-mp="36ooa5jo5xlvb">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8" data-id="element-120" data-mp="36n3d9nedlqua">
        <p className="font-serif text-2xl font-semibold text-white" data-id="element-121" data-mp="3ugbrb9vmhike">Screen &amp; Adapt™</p>
        <p className="mt-3 max-w-xl font-sans text-[15px] leading-[1.6] text-white/60" data-id="element-122" data-mp="37o2ul235f8m">
          The injury decision system for Pilates instructors who refuse to guess with other people's
          bodies.
        </p>

        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-123" data-mp="3qblvtm4vm600">
          {links.map(link => <li key={link.label} data-id="element-124" data-mp="29xm1qrsppako">
              <a href={link.href} className="font-sans text-[14px] text-white/70 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline" data-id="element-125" data-mp="2eya1q2yx51r1">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-12 border-t border-white/10 pt-8 font-sans text-[12px] leading-[1.7] text-white/45" data-id="element-126" data-mp="3v7ggi3ivygav">
          Screen &amp; Adapt™ is an educational reference for qualified movement professionals. It
          does not provide medical advice and does not diagnose, rehabilitate or manage any
          condition clinically. Every client with a known or suspected condition should be under the
          care of a licensed healthcare provider. When in doubt, refer out.
        </p>

        <p className="mt-6 font-sans text-[12px] text-white/40" data-id="element-127" data-mp="ctqmiq859xsj">
          © 2026 Screen &amp; Adapt™. All rights reserved.
        </p>
      </div>
    </footer>;
}